import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MAX_QUANTITY, PRODUCT_IMAGE_BASE_URL } from "../constants";
import style from "./ProductItem.module.css";
import PropTypes from "prop-types";
import { formatMoney } from "accounting-js";
import { connect } from "react-redux";
import { addQuoteItem } from "../redux/actions";
import QuantityInput from "./QuantityInput";
import { clamp } from "lodash-es";
import { Button } from "react-bootstrap";
import Image from "./shared/Image";
import Markdown from 'markdown-to-jsx';

class ProductItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qty: 1
    };
  }

  get url() {
    return `/product/${this.props.product.sku}`;
  }

  get image() {
    const path = this.getProductAttrValueByCode("image");

    return path ? `${PRODUCT_IMAGE_BASE_URL}${path}` : null;
  }

  get displayDescription() {
    const desc = this.getProductAttrValueByCode(
      this.props.product.type_id === "bundle"
        ? "bundle_inclusion_description"
        : "short_description"
    )
    // Truncate the text if too long
    return desc.length <= 100 ? desc : `${desc.substr(0, 100)}…`;
  }

  get quoteItem() {
    const { sku, name, id } = this.props.product;

    // Create the product item that is going to be added to the quote
    return {
      excludeFromMarginSplit:
        this.getProductAttrValueByCode("exclude_from_margin_split") === "1",
      image: this.image,
      isSoftware: this.getProductAttrValueByCode("ax_product_type") === "SW",
      isHardware: this.getProductAttrValueByCode("ax_product_type") !== "SW",
      isSaas: false, //there are currently no SaaS Simple Products
      name,
      price: this.price,
      productId: id,
      qty: this.state.qty,
      sku,
      type: "simple"
    };
  }

  get price() {
    return this.props.product.type_id === "simple" &&
      this.props.product.tier_prices[0]
      ? this.props.product.tier_prices[0].value
      : 0;
  }

  get isAvailable() {
    // 1: enabled; 2: disabled
    return this.props.product.status === 1;
  }

  get isSelectable() {
    return this.props.product.type_id === "simple";
  }

  getProductAttrValueByCode = attributeCode =>
    this.props.product.custom_attributes.reduce(
      (value, attr) =>
        attr.attribute_code === attributeCode ? attr.value : value,
      ""
    );

  handleQtyChange = e => {
    this.setState(
      { qty: clamp(Math.round(e.target.value), 1, MAX_QUANTITY) },
      () => this.props.handleQtyChange(this.quoteItem)
    );
  };

  handleSelect = () => {
    if (this.isAvailable && this.isSelectable) {
      this.props.handleSelect(this.quoteItem);
    }
  };

  handleAddToQuote = () => {
    this.props.addQuoteItem(this.quoteItem);
    this.props.history.push("/quote");
  };

  render() {
    return (
      <div
        className={[
          style.root,
          style[this.props.view],
          this.isAvailable ? "" : style.disabled,
          this.isSelectable ? style.selectable : "",
          this.props.isSelected ? style.selected : ""
        ].join(" ")}
        onClick={this.handleSelect}
      >
        <Link className={style.imageLink} to={this.url}>
          <Image
            className={style.image}
            src={this.image}
            alt={this.props.product.name}
          />
        </Link>

        <Link
          title={this.props.product.name}
          className={style.name}
          to={this.url}
        >
          {this.props.product.name}
        </Link>

        <div className={style.description}><Markdown>{this.displayDescription}</Markdown></div>

        {this.props.product.type_id === "simple" && (
          <span className={style.price}>{formatMoney(this.price)}</span>
        )}

        {this.props.product.type_id === "simple" && (
          <span className={style.subtotal}>
            {formatMoney(this.price * this.state.qty)}
          </span>
        )}

        {this.props.product.type_id === "simple" && (
          <QuantityInput
            type="number"
            className={style.qty}
            value={this.state.qty}
            onClick={e => e.stopPropagation()}
            onConfirm={this.handleQtyChange}
            disabled={!this.isAvailable}
          />
        )}

        {this.props.product.type_id === "bundle" ? (
          <Button
            as={Link}
            className={style.btnConfig}
            to={this.url}
            variant="primary"
          >
            Configure Product
          </Button>
        ) : (
          <Button
            variant="primary"
            disabled={!this.isAvailable}
            className={style.add}
            onClick={this.handleAddToQuote}
          >
            {this.props.view === "grid" ? "Add to Quote" : "Add Item"}
          </Button>
        )}
      </div>
    );
  }
}

ProductItem.propTypes = {
  product: PropTypes.object.isRequired,
  view: PropTypes.oneOf(["grid", "list"])
};

export default connect(undefined, { addQuoteItem })(ProductItem);
